export default __webpack_public_path__ + "static/media/Group 252.f3db73b6.svg";